<div class="date-range-wrapper">
  <div *ngFor="let days of daysArray" class="single-badge">
    <span (click)="setDays(days)">
      {{ 'components.date_range_picker.' + (isFutureTime ? 'set_next_days' : 'set_last_days') | translate: { days } }}
    </span>
  </div>
</div>
